import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import PropTypes from 'prop-types';

import styles from './MobilePersonListBottomSheet.module.scss';

/**
 * 모바일 인원 목록 바텀시트 컴포넌트
 * - 참조자/시행자 2명 이상일 때 전체 목록 표시
 */
function MobilePersonListBottomSheet({ isOpen, title, persons, onClose }) {
  // 바텀시트가 열릴 때 스크롤 방지
  useEffect(
    function () {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }

      return function () {
        document.body.style.overflow = '';
      };
    },
    [isOpen],
  );

  if (!isOpen) {
    return null;
  }

  // 인원 이름 목록 생성
  const personNames = persons.map(function (person) {
    return person.name || '-';
  });

  return createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.container}
        onClick={function (e) {
          e.stopPropagation();
        }}
      >
        {/* 제목 */}
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
        </div>

        {/* 인원 목록 박스 */}
        <div className={styles.content}>
          <div className={styles.personBox}>
            {personNames.map(function (name, index) {
              return (
                <span key={`person-${index}`} className={styles.personName}>
                  {name}
                  {index < personNames.length - 1 && <span className={styles.comma}>, </span>}
                </span>
              );
            })}
          </div>
        </div>

        {/* 확인 버튼 */}
        <div className={styles.footer}>
          <button type="button" className={styles.confirmButton} onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

MobilePersonListBottomSheet.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  persons: PropTypes.arrayOf(
    PropTypes.shape({
      enumber: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
  onClose: PropTypes.func,
};

MobilePersonListBottomSheet.defaultProps = {
  isOpen: false,
  title: '',
  persons: [],
  onClose: null,
};

export default MobilePersonListBottomSheet;
